import store from '@akerolabs/akero-vue/src/store/index.js'

/**
 * @param {Object} Vue
 * @param {Object} config
 * @description Constructor for creating the vuex store  angular service
 */
export default function vueStoreConstructor() {
  /**
   * @returns {Object}
   * @description Returns the vuex store service
   */
  return function vueStore() {
    return store
  }
}
